module.exports = __webpack_public_path__ + "img/Article-2021-02-24-1200-demo.ad173686.gif";